import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "./App.css";
import Login from "./pages/Login";
import Mainpage from "./pages/Mainpage";
import Subpage from "./pages/Subpage";
import { UserProvider } from "./components/Auth/userContext";
import PrivateRoute from "./components/Auth/PrivateRoute";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Preview from "./pages/Preview";

function App() {
  const [isToken, setIsToken] = useState(false);
  const { params } = useParams();
  const url = useLocation();
  const navigate = useNavigate();
  const [adminPanel, setAdminPanel] = useState();

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token && url.pathname === "/signin") {
      toast.warn("Already signed in");
      navigate("/digitalconversion/xml_to_dita");
    }
  }, [url.pathname, navigate]);

  console.log(url.pathname);

  useEffect(() => {
    if (
      url.pathname.includes("add_user") ||
      url.pathname.includes("edit_user") ||
      url.pathname.includes("delete_user")
    ) {
      setAdminPanel(true);
    }
  }, [url.pathname]);

  return (
    <div className="App">
      <UserProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/signin" replace />} />
          <Route path={"/:state"} element={<Login />}></Route>
          <Route
            path="/digitalconversion"
            element={
              <PrivateRoute>
                <Mainpage
                  adminPanel={adminPanel}
                  setAdminPanel={setAdminPanel}
                />
              </PrivateRoute>
            }
          >
            <Route
              path=":fileId?/:category?/:pages"
              element={
                <Subpage
                  adminPanel={adminPanel}
                  setAdminPanel={setAdminPanel}
                />
              }
            />
          </Route>
          <Route path="/preview/:fileid?" element={<Preview />} />
        </Routes>
      </UserProvider>
    </div>
  );
}

export default App;
